import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReviewService } from '../review.service';

import {
  ReviewHistoryActionTypes,
  ReviewHistoryLoadedAction,
  ReviewHistoryLoadingFailedAction,
  ReviewHistoryRequestedAction,
  ReviewHistoryShowModalAction,
} from './review-history.actions';

@Injectable()
export class ReviewHistoryEffects {
  showReviewHistoryModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReviewHistoryActionTypes.REVIEW_HISTORY_SHOW_MODAL),
      map(
        (action: ReviewHistoryShowModalAction) =>
          new ReviewHistoryRequestedAction(action.payload),
      ),
    ),
  );

  loadReviewHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReviewHistoryActionTypes.REVIEW_HISTORY_REQUESTED),
      switchMap((action: ReviewHistoryRequestedAction) => {
        const { listId } = action.payload;
        return this.reviewService.getReviewHistory(listId).pipe(
          map(
            reviews =>
              new ReviewHistoryLoadedAction({
                ...action.payload,
                reviews,
              }),
          ),
          catchError(error =>
            observableOf(
              new ReviewHistoryLoadingFailedAction({
                ...action.payload,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private reviewService: ReviewService,
  ) {}
}
